import React, { useState } from 'react'
import { Edit, email, required, Toolbar, TopToolbar, useTranslate, SimpleForm, SaveButton, useNotify } from 'react-admin'
import { useTheme, Typography, Button } from '@mui/material';
import styledFormInputs from '../../../ui/inputs/styledFormInputs';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';
import ChangePasswordDialog from './ChangePasswordDialog';



const lang = [
    { id: 'fr', name: 'resources.users.lang.fr' },
    { id: 'en', name: 'resources.users.lang.en' }
]

const validateRequired = [required('Champs obligatoire')]
const validateEmail = [required('Champs obligatoire'), email('Syntaxe incorrecte')]


// top toolbar: "Change my password" opens the dialog (password change goes
// through uaa, which verifies the current password against Cognito server-side).
// TopToolbar, not the form Toolbar: on phones the form Toolbar becomes a bar
// fixed to the bottom of the screen, where the Save toolbar then covers it.
const AccountEditActions = ({ onChangePassword }) => {
    const translate = useTranslate();
    return (
        <TopToolbar>
            <Button onClick={onChangePassword}>
                {translate("resources.users.change_my_password")}
            </Button>
        </TopToolbar>
    )
}

const AccountEditToolbar = () => {
    return (
        <Toolbar>
            <SaveButton />
        </Toolbar>
    )
}


const AccountEdit = (() => {
    const translate = useTranslate();
    const theme = useTheme();
    const notify = useNotify();
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
    const inputsData = [
        { name: 'first_name', label: translate('resources.users.first_name'), validate: validateRequired, type: "text" },
        { name: 'last_name', label: translate('resources.users.last_name'), validate: validateRequired, type: "text" },
        { name: 'email', label: translate('resources.users.email'), validate: validateEmail, type: "text", disabled: true },
        { name: 'lang_key', label: translate('resources.users.language'), validate: validateRequired, type: "select", choices: lang, },
        { name: 'organization_id', label: translate('resources.organization.organization'), validate: validateRequired, type: "reference", reference: "organizations", optionText: "name", disabled: true },
    ]


    return (

        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.account.edit')}
            </Typography>
            <Edit
                title={translate('resources.account.edit')}
                actions={<AccountEditActions onChangePassword={() => setPasswordDialogOpen(true)} />}
                mutationMode="pessimistic"
                mutationOptions={{
                    onSuccess: () => {
                        notify(translate('resources.common.update_success'), { type: 'info' });
                    }
                }}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
            >

                <SimpleForm
                    toolbar={<AccountEditToolbar />}
                    actions
                >

                    {styledFormInputs(inputsData)}

                </SimpleForm>

            </Edit>

            <ChangePasswordDialog open={passwordDialogOpen} onClose={() => setPasswordDialogOpen(false)} />
        </>
    )
}
);

export default (AccountEdit)
